
<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" size="small" placeholder="请输入用户ID"></el-input>
                </el-col>
                 <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制审核状态" :value="0"></el-option>
                        <el-option label="仅看待审核的" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1" class="color-warning">待审核</span>
                        <span v-else-if="scope.row.status==2" class="color-success">已通过</span>
                        <span v-else-if="scope.row.status==3" class="color-info">已拒绝</span>
                        <span v-else-if="scope.row.status==4" class="color-danger">已撤销</span>
                    </template>
                </el-table-column>	
                <el-table-column prop="userType" label="身份" >
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="userName" label="用户名" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userStatus" label="账号状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.userStatus == 1" type="success" size="mini">正常</el-tag>
                        <el-tag v-else type="info" size="mini">注销</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="申请修改时间" min-width="150"></el-table-column>
                <el-table-column prop="auditorTime" label="审核时间" min-width="150"></el-table-column>
                <el-table-column prop="auditorName" label="审核人" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/realname/audit/detail')"
                            type="text"
                            size="small"
                            :icon="scope.row.status==1 ? 'el-icon-coordinate' : 'el-icon-view'"
                            @click="view(scope.row.operationRecordId)"
                            >{{ scope.row.status==1 ? '审核' : '查看'}}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <detail-view ref="detailView" @onSuccess="getDataList"></detail-view>
    </div>
</template>

<script>
import DetailView from './components/detailView';
const defaultParams = {
    pageNo:1,
    queryType: 0,
	queryValue: "",
	status: 1
}
export default {
    components:{DetailView},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize:this.$pageSizes[0],
            },
            listLoading: false,    
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/realname/audit/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //详情
        view(id){
            this.$refs.detailView.show(id)
        }
    }
}
</script>